import {
  AdminPanelSettings as AdminIcon,
  CompareArrows as CompareIcon,
  Dashboard as DashboardIcon,
  Dns as OpsIcon,
  EmojiEvents as GreatsIcon,
  Forum as ForumIcon,
  Groups as TeamsIcon,
  Home as HomeIcon,
  Insights as OverviewIcon,
  People as UsersIcon,
  Person as PersonIcon,
  PersonSearch as PlayersIcon,
  Psychology as TriviaIcon,
  QueryStats as ExplorerIcon,
  Share as ShareIcon,
  SportsKabaddi as CommunityIcon,
  Quiz as QuizIcon,
  SportsBaseball as BaseballIcon,
  SportsBasketball as BasketballIcon,
  SportsFootball as FootballIcon,
  Stadium as LineupIcon,
} from "@mui/icons-material";

export const SPORT_ICONS = {
  mlb: BaseballIcon,
  nba: BasketballIcon,
  nfl: FootballIcon,
};

export const DESTINATION_ICONS = {
  home: HomeIcon,
  compare: CompareIcon,
  players: PlayersIcon,
  teams: TeamsIcon,
  queryBuilder: ExplorerIcon,
  trivia: TriviaIcon,
  community: CommunityIcon,
  allTimeGreats: GreatsIcon,
  dashboard: DashboardIcon,
  lineup: LineupIcon,
  profile: PersonIcon,
  admin: AdminIcon,
  adminOverview: OverviewIcon,
  adminDashboard: OverviewIcon,
  adminOps: OpsIcon,
  adminTrivia: QuizIcon,
  adminUsers: UsersIcon,
  adminCommunity: ForumIcon,
  adminSocial: ShareIcon,
};
